<template>
	<section class="page-reset-prompt custom-scrollbar">
		<LogoHeader :noSep="true" />
		<p>
			Check your email <span class="text-primary">{{ email }}</span> for
			reset link.
		</p>
		<router-link
			class="max-width btn btn-secondary mt-5"
			:to="{ path: '/console/login' }"
			>Back to Login</router-link
		>
	</section>
</template>

<script>
import LogoHeader from "../shared/LogoHeader";

export default {
	name: "ResetPrompt",
	components: {
		LogoHeader,
	},
	data() {
		return {
			email: "",
		};
	},
	mounted() {
		this.email = this.$route.query.email;
	},
};
</script>

<style scoped>

.page-reset-prompt {
	padding: 3em;
	max-width: 30em;
	margin: 0 auto;
}

</style>